import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { IStoreState } from "../../../../../../reducers/types";
import {
  getHotelAvailabilityCentroids,
  getHotelAvailabilitySearchBoundingBox,
} from "../../../../reducer/selectors";

import { PreviewMap } from "./component";

const mapStateToProps = (state: IStoreState) => {
  const searchCentroids = getHotelAvailabilityCentroids(state);
  const searchBoundingBox = getHotelAvailabilitySearchBoundingBox(state);

  return {
    searchCentroids,
    searchBoundingBox,
  };
};

const connector = connect(mapStateToProps);

export type PreviewMapConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedPreviewMap = withRouter(connector(PreviewMap));
